export const DASHBOARD_PAGE_ID = 'dashboard-page';
export const BASE_WIDGET_CLASS = 'rnd-widget';

export const MIN_CSS_WIDTH = '700px';
export const MIN_CSS_HEIGHT = '430px';
export const INITIAL_POSITION_X = 0;
export const INITIAL_POSITION_Y = 0;
